module.exports = __webpack_public_path__ + "static/media/welcomeCIO_Gnomes.18d17abd.svg";